<mat-card class="cardWithShadow">
    <app-loader></app-loader>
    <mat-card-content class="p-0">
        <mat-tab-group mat-stretch-tabs="false" animationDuration="0ms">
            <form [formGroup]="userDetailsForm">
                <mat-tab>
                    <ng-template mat-tab-label>
                        <div class="d-flex align-items-center">
                            <mat-icon>
                                <i-tabler name="user-circle" class="icon-20 m-r-8"></i-tabler>
                            </mat-icon>
                        </div>
                        {{ 'ENTITY.PERSONAL' | translate }}
                    </ng-template>
                    <mat-card-content class="p-y-12 b-t-1">
                        <div class="row">
                            <div class="col-sm-9">
                                <mat-card-content>
                                    <mat-card-title>{{ 'ENTITY.PERSONAL' | translate }}</mat-card-title>
                                    <mat-card-subtitle class="mat-body-1">{{ 'LABEL.PERSONAL_DESCRIPTION' | translate
                                        }}</mat-card-subtitle>

                                    <div class="row m-t-24">
                                        <div class="col-sm-6 ">
                                            <!-- input -->

                                            <mat-form-field appearance="outline" class="w-100 m-b-16" color="primary">
                                                <mat-label>{{ 'LABEL.FIRSTNAME_LABEL' | translate }}</mat-label>
                                                <input matInput type="text" formControlName="firstname" />
                                                <mat-error
                                                    *ngIf="userDetailsForm.get('firstname')?.hasError('required')">
                                                    {{ 'REQUIRED.NAME' | translate }}
                                                </mat-error>
                                            </mat-form-field>

                                            <mat-form-field appearance="outline" class="w-100 m-b-16" color="primary">
                                                <mat-label>{{ 'LABEL.LASTNAME_LABEL' | translate }}</mat-label>
                                                <input matInput type="text" formControlName="lastname" />
                                                <mat-error
                                                    *ngIf="userDetailsForm.get('lastname')?.hasError('required')">
                                                    {{ 'REQUIRED.NAME' | translate }}
                                                </mat-error>
                                            </mat-form-field>
                                            <!-- input -->

                                            <mat-form-field appearance="outline" class="w-100 m-b-16" color="primary">
                                                <mat-label>{{ 'LABEL.EMAIL_LABEL' | translate }}</mat-label>
                                                <input matInput type="email" formControlName="email" readonly />
                                            </mat-form-field>

                                            <mat-form-field appearance="outline" class="w-100 m-b-16">
                                                <mat-label>{{ 'LABEL.DOB_LABEL' | translate }}</mat-label>
                                                <input matInput [matDatepicker]="picker" formControlName="birthDate"
                                                    [min]="minDate" [max]="maxDate" required readonly
                                                    (click)="picker.open()" (focus)="picker.open()">
                                                <mat-hint>DD/MM/YYYY</mat-hint>
                                                <mat-datepicker-toggle matIconSuffix
                                                    [for]="picker"></mat-datepicker-toggle>
                                                <mat-datepicker #picker [color]="'primary'"></mat-datepicker>
                                                <mat-error
                                                    *ngIf="userDetailsForm.get('birthDate')?.hasError('required') && userDetailsForm.get('birthDate')?.touched">
                                                    {{ 'REQUIRED.SELECT_DATE' | translate }}
                                                </mat-error>
                                            </mat-form-field>


                                        </div>
                                        <div class="col-sm-6">
                                            <!-- input -->



                                            <mat-form-field appearance="outline" class="w-100 m-b-16" color="primary">
                                                <mat-label>{{ 'LABEL.PHONE_LABEL' | translate }}</mat-label>
                                                <input matInput type="text" formControlName="phoneNumber" minlength="10"
                                                    maxlength="10" appAllowOnlyDigits />
                                                <mat-error
                                                    *ngIf="userDetailsForm.get('phoneNumber')?.hasError('required')">
                                                    {{ 'REQUIRED.NAME' | translate }}
                                                </mat-error>
                                                <mat-error
                                                    *ngIf="userDetailsForm.get('phoneNumber')?.hasError('minlength')">
                                                    {{ 'REQUIRED.MINIMUM10' | translate }}
                                                </mat-error>
                                            </mat-form-field>

                                            <mat-form-field appearance="outline" class="w-100 m-b-16">
                                                <mat-label>{{ 'LABEL.JOINDATE_LABEL' | translate }}</mat-label>
                                                <input matInput [matDatepicker]="pickerjoin" formControlName="joinDate"
                                                    [min]="minDate" [max]="maxDate" (click)="pickerjoin.open()"
                                                    (focus)="pickerjoin.open()">
                                                <mat-hint>DD/MM/YYYY</mat-hint>
                                                <mat-datepicker-toggle matIconSuffix
                                                    [for]="pickerjoin"></mat-datepicker-toggle>
                                                <mat-datepicker #pickerjoin [color]="'primary'"></mat-datepicker>
                                                <mat-error
                                                    *ngIf="userDetailsForm.get('joinDate')?.hasError('required') && userDetailsForm.get('joinDate')?.touched">
                                                    {{ 'REQUIRED.SELECT_DATE' | translate }}
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-12 m-t-24">
                                            <!-- input -->

                                            <mat-form-field appearance="outline" class="w-100" color="primary">
                                                <mat-label>{{ 'LABEL.ADDRESS_LABEL' | translate }}</mat-label>
                                                <input matInput type="text" formControlName="address" />
                                                <mat-error
                                                    *ngIf="userDetailsForm.get('address')?.hasError('required')">
                                                    {{ 'REQUIRED.NAME' | translate }}
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                         <div class="col-sm-4" *ngIf="isDoctor">
                                            <mat-form-field appearance="outline" class="w-100 m-b-16">
                                                <mat-label>{{ 'LABEL.REGISTRATION_NUMBER' | translate }}</mat-label>
                                                <input matInput type="text" formControlName="registrationNumber" maxlength="20"/>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-sm-4" *ngIf="isDoctor">
                                            <mat-form-field appearance="outline" class="w-100 m-b-16">
                                                <mat-label>{{ 'LABEL.DEGREE' | translate }}</mat-label>
                                                <input matInput type="text" formControlName="degree" />
                                            </mat-form-field>
                                        </div>

                                        <div class="col-sm-4" *ngIf="isDoctor">
                                            <mat-form-field appearance="outline" class="w-100 ">
                                                <mat-label>{{ 'ENTITY.SPECIALITY' | translate }}</mat-label>
                                                <mat-select formControlName="specialityId">
                                                    <mat-option *appHasRole="ROLE_GROUPS.AllTenant" class="f-s-16 f-w-600" (click)="onAddSpeciality()">
                                                        Add Speciality
                                                    </mat-option>
                                                    @for (speciality of DoctorSpeciality; track speciality) {
                                                    <mat-option [value]="speciality.id">{{speciality.name}}</mat-option>
                                                    }
                                                </mat-select>
                                            </mat-form-field>
                                        </div>

                                        <div class="col-sm-4" *ngIf="isDoctor">
                                            <mat-form-field appearance="outline" class="w-100 m-b-16">
                                                <mat-label>{{ 'LABEL.HPR_ID' | translate }}</mat-label>
                                                <input matInput type="text" formControlName="hprId" maxlength="17"/>
                                                <mat-error *ngIf="userDetailsForm.get('hprId')?.hasError('pattern')">
                                                    {{ 'VALIDATION.HPR_ID_INVALID' | translate }}
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </mat-card-content>
                            </div>
                            <div class="col-sm-3">
                                <mat-card class="cardWithShadow m-t-24">
                                    <mat-card-content class="p-y-24">
                                        <mat-card-title>{{ 'ENTITY.CHANGE_PROFILE' | translate }}</mat-card-title>
                                        <mat-card-subtitle class="mat-body-1">{{ 'ENTITY.CHANGE_DESCRIPTION' | translate
                                            }}</mat-card-subtitle>
                                        <div class="m-t-24">


                                            <div class="flex flex-col items-center relative" id="avatar-container"
                                                (mouseenter)="showAddPhotoOverlay=true">
                                                @if(imageUrl){
                                                <img class="avatar-photo" #avatarImg [src]="imageUrl" id="avatar-photo"
                                                    alt="User avatar">

                                                }@else {
                                                <img class="avatar-photo" #avatarImg
                                                    [src]="userdetail?.avatar && userdetail?.avatar !== '' ? userdetail?.avatar : defaultAvatarPath"
                                                    id="avatar-photo" alt="User avatar"
                                                    fallbackImage="assets/images/profile/user-1.jpg">
                                                }


                                                <div *ngIf="showAddPhotoOverlay" id="add-photo-overlay"
                                                    class="avatar-photo" style="text-align: center;"
                                                    [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger"
                                                    (mouseenter)="openMenu(menuTrigger)">
                                                    <button id="add-avatar-photo-button" class="center-positon-absolute"
                                                        mat-icon-button>
                                                        <mat-icon>add_a_photo</mat-icon>
                                                    </button>

                                                    <!-- Hover Menu -->
                                                    <mat-menu #menu="matMenu" (closed)="onMenuClosed()">
                                                        <button mat-menu-item (click)="takePhotoOnWebCamera()">
                                                            {{ 'LABEL.TAKE_PHOTO' | translate }}
                                                            <mat-icon>photo_camera</mat-icon>
                                                        </button>
                                                        <button mat-menu-item
                                                            (click)="fileInput.click();showAddPhotoOverlay=false">
                                                            {{ 'LABEL.BROWSER_PHOTO' | translate }}
                                                            <mat-icon>collections icon</mat-icon>
                                                        </button>
                                                    </mat-menu>
                                                    <!-- <mat-icon id="remove-avatar-photo-button"
                                                        *ngIf="imageUrl && imageUrl !== ''" (click)="removePhoto()"
                                                        matTooltip="remove this photo">close</mat-icon> -->
                                                </div>

                                                <!-- Input file -->
                                                <input #fileInput type="file" (change)="onFileChanged($event)"
                                                    name="avatar" accept="image/png, image/jpeg" style="display:none;">
                                            </div>
                                            <span class="f-s-14 m-t-24 d-block">{{ 'VALIDATION.PHOTO_VALID' | translate
                                                }}</span>
                                        </div>
                                    </mat-card-content>
                                </mat-card>
                            </div>

                        </div>
                    </mat-card-content>
                    <div class="p-24 btn-update">
                        <mat-spinner *ngIf="isLoading" diameter="24"></mat-spinner>
                        <button mat-flat-button color="primary" class="m-r-8" [disabled]="userDetailsForm.invalid"
                            (click)="onUpdateUserProfile()">
                            <span>{{ 'BUTTON.BTN_SAVE' | translate }}</span>
                        </button>

                        <!-- <button mat-stroked-button color="primary">Cancel</button> -->
                    </div>
                </mat-tab>

            </form>

            <mat-tab>
                <ng-template mat-tab-label>
                    <div class="d-flex align-items-center">
                        <mat-icon>
                            <i-tabler name="brand-samsungpass" class="icon-20 m-r-8"></i-tabler>
                        </mat-icon>
                    </div>
                    {{ 'LABEL.CHANGE_PASSWORD_LABEL' | translate }}
                </ng-template>
                <mat-card-content class="p-y-24 b-t-1">
                    <app-change-password></app-change-password>
                </mat-card-content>
            </mat-tab>

            <mat-tab *ngIf="isDoctor && userdetail?.id">
                <ng-template mat-tab-label>
                    <div class="d-flex align-items-center">
                        <mat-icon>
                            <i-tabler name="stethoscope" class="icon-20 m-r-8"></i-tabler>
                        </mat-icon>
                    </div>
                    {{ 'LABEL.AVAILABILITY' | translate }}
                </ng-template>

                <app-availability [userId]="userdetail.id" [userRole]="getRolesArray(userdetail?.roleName)"
                    (availability)="avalibilityCheck($event)">
                </app-availability>
            </mat-tab>
        </mat-tab-group>

    </mat-card-content>
</mat-card>
